import { nativeDrivers } from '../../../DataSource';

export const useApolloFederationSupportedDrivers = () => {
  return nativeDrivers;
};
